import {
  FETCH_SESSION_BEGIN,
  FETCH_SESSION_SUCCESS,
  FETCH_SESSION_FAILURE,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE
} from 'actions/session';

const initialState = {
  user: false,
  isLoading: false,
  isLoggedin: false,
};

export default function sessionReducer(state = initialState, { type = '', session, ...next }) {
  switch (type) {
    case FETCH_SESSION_BEGIN:
      return { ...state, isLoading: true };
    case FETCH_SESSION_SUCCESS:
      return { ...state, isLoggedin: session.isLoggedin, user: session.aprofiel, isLoading: false };
    case FETCH_SESSION_FAILURE:
      return { ...state, isLoading: false };
    case LOGOUT_BEGIN:
      return { ...state, isLoading: true };
    case LOGOUT_SUCCESS:
      const { user, ...noSessionState } = state;
      return { ...noSessionState, isLoading: false };
    case LOGOUT_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}